module.exports = __webpack_public_path__ + "static/media/VehicleIcon.af9c6205.svg";